import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {RoutesService} from '@raven';
import {CatalogRecord} from '@store/common/common.types';

@Component({
  selector: 'rn-combined-cover-title-barcode',
  templateUrl: './combined-cover-title-barcode.component.html',
  styles: `
      a {
          line-height: 1.25rem
      }

      .item {
          max-height: 2.5rem;
          max-width: 3rem;
          padding: 0.25rem 0.5rem;
      }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CombinedCoverTitleBarcodeComponent {
  @Input() public catalogRecord: CatalogRecord;
  @Input() public barcode?: string;
  public readonly routingService = inject(RoutesService);
}
